<template>
  <div :class="[_.empty, noMargin && _.noMargin]">
    <img :src="iconUrl" :class="_.icon" :style="iconStyle" />
    <div :class="_.message">
      {{ message }}
    </div>
    <div v-if="$slots.default" :class="_.actions">
      <slot />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { pxToRem } from '@/utils'

  export default Vue.extend({
    props: {
      // 图标
      icon: {
        type: String,
        default: require('./images/空.png'),
      },

      // 图标宽度
      iconWidth: {
        type: Number,
        default: 300,
      },

      // 信息
      message: {
        type: String,
        default: '暂无数据',
      },

      // 无边距
      noMargin: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      iconUrl() {
        return this.icon
      },
      iconStyle() {
        return {
          width: `${pxToRem(this.iconWidth)}rem`,
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .empty {
    padding: 100px 0;
    text-align: center;
    user-select: none;
    -webkit-touch-callout: none;

    .message {
      margin-top: 20px;
      font-size: 36px;
      color: rgba(255, 255, 255, 0.6);
    }

    .actions {
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &.noMargin {
      padding: 0;
    }
  }
</style>
